export var LessonType;
(function (LessonType) {
    LessonType[LessonType["UNKNOWN"] = 0] = "UNKNOWN";
    LessonType[LessonType["LESSON"] = 1] = "LESSON";
    LessonType[LessonType["EXERCISE"] = 2] = "EXERCISE";
    LessonType[LessonType["REVIEW"] = 3] = "REVIEW";
})(LessonType || (LessonType = {}));
export var TotalLessonCount;
(function (TotalLessonCount) {
    TotalLessonCount[TotalLessonCount["C1_AND_C2"] = 42] = "C1_AND_C2";
    TotalLessonCount[TotalLessonCount["C9X"] = 9] = "C9X";
})(TotalLessonCount || (TotalLessonCount = {}));
export var TeachingPointType;
(function (TeachingPointType) {
    TeachingPointType[TeachingPointType["KNOWLEDGE_POINT"] = 0] = "KNOWLEDGE_POINT";
    TeachingPointType[TeachingPointType["CONGNITIVE_PROCESS"] = 1] = "CONGNITIVE_PROCESS";
    TeachingPointType[TeachingPointType["APPLY_ABILITY"] = 2] = "APPLY_ABILITY";
})(TeachingPointType || (TeachingPointType = {}));
export var LessonStatus;
(function (LessonStatus) {
    LessonStatus[LessonStatus["COMING"] = 0] = "COMING";
    LessonStatus[LessonStatus["LOCKED"] = 1] = "LOCKED";
    LessonStatus[LessonStatus["UNLOCKED"] = 2] = "UNLOCKED";
    LessonStatus[LessonStatus["HIGHLIGHT"] = 3] = "HIGHLIGHT";
    LessonStatus[LessonStatus["PLAYED"] = 4] = "PLAYED";
})(LessonStatus || (LessonStatus = {}));
//# sourceMappingURL=evaluation.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/types/evaluation.js
// module id = 1223
// module chunks = 0